// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum DecoratorStyle {
  None = 0,
  Bullet = 1,
  Number = 2,
  CheckBox = 3,
  BlockQuote = 4,
  CodeBlock = 5
}
